import { SecurityGraphFilters } from 'containers/Visibility/SecurityGraphNext/Components/SecutiryGraphFilters';

export const AccessSidebar = () => {
  return <SecurityGraphFilters />;
};
